
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Stratégie d'enchères automatisées vs manuelles sur Google Ads !",
    description:
      "Enchères automatisées ou manuelles sur Google Ads : quelles différences ? ALEO vous aide à choisir la meilleure stratégie selon vos objectifs pour maximiser le ROI.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
